// @ts-check
// ====== F4: Calendario unico — scadenze + contratti + to-do + audit critici ======
// Estende il calendario delle scadenze sovrapponendo to-do personali dell'utente
// e voci di audit critiche (delete cliente, restore backup, clear storico).
//
// Si attiva come "Calendario unico" nella vista Scadenze (segmented già esistente)
// e come vista standalone tramite setView('calendario').

const CU_DOW = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
const CU_MONTHS = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre'
];

let _cuCursor = startOfMonthCU(new Date());
const _cuFilters = { scadenze: true, contratti: true, todos: true, audit: false };

function startOfMonthCU(d) {
  const x = new Date(d);
  x.setDate(1);
  x.setHours(0, 0, 0, 0);
  return x;
}
function padCU(n) {
  return String(n).padStart(2, '0');
}
function ymdCU(d) {
  return `${d.getFullYear()}-${padCU(d.getMonth() + 1)}-${padCU(d.getDate())}`;
}

async function collectCalendarioUnico() {
  const out = [];
  // 1) Scadenze classiche
  if (_cuFilters.scadenze) {
    // @ts-ignore — state globale
    (state?.clients || []).forEach((c) => {
      (c.scadenze || []).forEach((s) => {
        if (!s.data) return;
        out.push({
          kind: 'scadenza',
          cliente: c.nome,
          data: s.data,
          titolo: s.titolo || '(senza titolo)',
          tipo: s.tipo || '',
          completata: !!s.completata,
          openTab: 'scadenze'
        });
      });
    });
  }
  // 2) Contratti
  if (_cuFilters.contratti) {
    // @ts-ignore
    (state?.clients || []).forEach((c) => {
      if (c.contratto?.fine) {
        out.push({
          kind: 'contratto',
          cliente: c.nome,
          data: c.contratto.fine,
          titolo: 'Fine contratto',
          tipo: c.contratto?.numero || 'Contratto',
          openTab: 'contratto'
        });
      }
    });
  }
  // 3) To-do personali
  if (_cuFilters.todos) {
    try {
      // @ts-ignore — todosApi globale
      const todos = (await todosApi?.list?.()) || [];
      todos.forEach((t) => {
        if (!t.data_scadenza) return;
        out.push({
          kind: 'todo',
          todoId: t.id,
          cliente: '',
          data: t.data_scadenza,
          titolo: t.titolo,
          tipo: t.completata ? '✓ Completata' : 'To-do',
          completata: !!t.completata
        });
      });
    } catch (_) {
      /* silent */
    }
  }
  // 4) Audit critici (delete cliente / restore backup)
  if (_cuFilters.audit) {
    // @ts-ignore
    (state?.auditLog || [])
      .filter(
        (a) =>
          a.action === 'delete' ||
          (a.entity === 'Backup' && a.target === 'Ripristino') ||
          a.target === 'Storico'
      )
      .forEach((a) => {
        out.push({
          kind: 'audit',
          cliente: a.target || '',
          data: a.timestamp,
          titolo: `${a.entity} · ${a.action}`,
          tipo: a.user || ''
        });
      });
  }
  return out;
}

function cuPillClass(item) {
  if (item.kind === 'todo') return `cal-pill cu-todo${item.completata ? ' done' : ''}`;
  if (item.kind === 'audit') return 'cal-pill cu-audit';
  if (item.kind === 'contratto') return 'cal-pill danger';
  // scadenze
  if (item.completata) return 'cal-pill done';
  // @ts-ignore — daysUntil globale
  const g = typeof daysUntil === 'function' ? daysUntil(item.data) : null;
  if (g == null) return 'cal-pill';
  if (g < 0) return 'cal-pill danger';
  if (g <= 30) return 'cal-pill warn';
  return 'cal-pill ok';
}

async function renderCalendarioUnico(rootSel) {
  const root =
    typeof rootSel === 'string'
      ? document.getElementById(rootSel)
      : rootSel || document.getElementById('calUnicoRoot');
  if (!root) return;

  // Header (mese, navigazione, filtri)
  const cur = _cuCursor;
  const year = cur.getFullYear();
  const month = cur.getMonth();

  root.innerHTML = `
    <div class="card-header" style="border-bottom: 1px solid var(--border); padding-bottom: 12px; margin-bottom: 12px">
      <div style="display:flex;gap:8px;align-items:center;">
        <button class="btn btn-sm" id="cuPrev" aria-label="Mese precedente">‹</button>
        <strong id="cuMonthLabel" style="min-width:160px;text-align:center;">${CU_MONTHS[month]} ${year}</strong>
        <button class="btn btn-sm" id="cuNext" aria-label="Mese successivo">›</button>
        <button class="btn btn-sm" id="cuToday">Oggi</button>
      </div>
      <div class="cu-legend" id="cuFilters">
        ${legendToggle('scadenze', 'cu-scadenza', 'Scadenze')}
        ${legendToggle('contratti', 'cu-contratto', 'Contratti')}
        ${legendToggle('todos', 'cu-todo', 'To-do')}
        ${legendToggle('audit', 'cu-audit', 'Audit critici')}
      </div>
    </div>
    <div id="cuGrid"></div>`;

  root.querySelectorAll('[data-cu-toggle]').forEach((cb) => {
    cb.addEventListener('change', () => {
      _cuFilters[cb.dataset.cuToggle] = cb.checked;
      renderCalendarioUnico(root);
    });
  });
  root.querySelector('#cuPrev').addEventListener('click', () => {
    _cuCursor = new Date(_cuCursor.getFullYear(), _cuCursor.getMonth() - 1, 1);
    renderCalendarioUnico(root);
  });
  root.querySelector('#cuNext').addEventListener('click', () => {
    _cuCursor = new Date(_cuCursor.getFullYear(), _cuCursor.getMonth() + 1, 1);
    renderCalendarioUnico(root);
  });
  root.querySelector('#cuToday').addEventListener('click', () => {
    _cuCursor = startOfMonthCU(new Date());
    renderCalendarioUnico(root);
  });

  // Carica dati e disegna la griglia
  const grid = root.querySelector('#cuGrid');
  grid.innerHTML = '<div class="muted" style="padding:20px;">Caricamento…</div>';

  const all = await collectCalendarioUnico();
  const first = new Date(year, month, 1);
  const dowFirst = (first.getDay() + 6) % 7;
  const gridStart = new Date(year, month, 1 - dowFirst);

  const byDay = new Map();
  for (let i = 0; i < 42; i++) {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    byDay.set(ymdCU(d), []);
  }
  all.forEach((it) => {
    const k = (it.data || '').slice(0, 10);
    if (byDay.has(k)) byDay.get(k).push(it);
  });
  const today = ymdCU(new Date());

  let html = '<div class="cal-head">';
  CU_DOW.forEach((d) => (html += `<div class="cal-dow">${d}</div>`));
  html += '</div><div class="cal-cells">';
  for (let i = 0; i < 42; i++) {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    const k = ymdCU(d);
    const inMonth = d.getMonth() === month;
    const isToday = k === today;
    const items = byDay.get(k) || [];
    const visible = items.slice(0, 4);
    const more = items.length - visible.length;
    html += `<div class="cal-cell ${inMonth ? '' : 'out'} ${isToday ? 'today' : ''}" data-d="${k}">
      <div class="cal-day-num">${d.getDate()}</div>
      <div class="cal-pills">${visible
        .map(
          (it) =>
            `<button type="button" class="${cuPillClass(it)}" data-kind="${it.kind}" data-cliente="${escapeHtml(it.cliente || '')}" data-todoid="${escapeHtml(it.todoId || '')}" title="${escapeHtml(it.cliente ? it.cliente + ' — ' : '')}${escapeHtml(it.titolo)}${it.tipo ? ' (' + escapeHtml(it.tipo) + ')' : ''}">
            ${escapeHtml(it.cliente ? it.cliente + ' · ' + it.titolo : it.titolo)}
          </button>`
        )
        .join('')}${more > 0 ? `<span class="cal-more">+${more}</span>` : ''}</div>
    </div>`;
  }
  html += '</div>';
  grid.innerHTML = html;

  grid.querySelectorAll('.cal-pill').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const kind = btn.dataset.kind;
      const cli = btn.dataset.cliente;
      if (kind === 'todo') {
        // @ts-ignore — setView globale
        if (typeof setView === 'function') setView('todos');
      } else if (cli) {
        // @ts-ignore — openModal globale
        if (typeof openModal === 'function')
          openModal(cli, kind === 'contratto' ? 'contratto' : 'scadenze');
      }
    });
  });
}

function legendToggle(key, dotClass, label) {
  const checked = _cuFilters[key] ? 'checked' : '';
  return `<label class="cu-legend-item" style="cursor:pointer;">
    <input type="checkbox" data-cu-toggle="${key}" ${checked} style="width:auto;margin-right:4px;" />
    <span class="cu-legend-dot ${dotClass}"></span>${label}
  </label>`;
}

// @ts-ignore — registra global
Object.assign(globalThis, { renderCalendarioUnico });
export {};
